/** Empty-state illustration for the Work Orders listing — clipboard with a green check. */
const EmptyWorkOrderSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="161" viewBox="0 0 160 161" fill="none">
            <g clipPath="url(#clip0_1_21659)">
                <path
                    d="M10 5.03125H120C125.522 5.03125 130 9.53673 130 15.0938V150.938C130 156.495 125.522 161 120 161H10C4.4775 161 0 156.495 0 150.938V15.0938C0 9.53673 4.4775 5.03125 10 5.03125Z"
                    fill="#006CDD"
                />
                <path d="M10 117.802V15.0938H120V150.938H42.9297L10 117.802Z" fill="#EFEFEF" />
                <path
                    d="M42.9297 117.802V150.938L10 117.802H42.9297ZM40 20.125V0H90V20.125C90 25.682 85.5225 30.1875 80 30.1875H50C44.4775 30.1875 40 25.682 40 20.125Z"
                    fill="#2196F3"
                />
                <path
                    d="M160 115.719C160 140.726 139.852 161 115 161C90.1478 161 70 140.726 70 115.719C70 90.7112 90.1478 70.4375 115 70.4375C139.852 70.4375 160 90.7112 160 115.719Z"
                    fill="#40D158"
                />
                <path
                    d="M104.69 135.104L95 125.349C93.0482 123.384 93.0482 120.198 95 118.234C96.9519 116.27 100.117 116.27 102.07 118.234L105.31 121.49L127.955 102.497C130.077 100.716 133.233 101.005 135 103.141C136.77 105.276 136.483 108.451 134.36 110.229L104.69 135.104Z"
                    fill="white"
                />
                <path
                    d="M55 40.25H95C97.7613 40.25 100 42.5027 100 45.2812C100 48.0598 97.7613 50.3125 95 50.3125H55C52.2388 50.3125 50 48.0598 50 45.2812C50 42.5027 52.2388 40.25 55 40.25ZM30 40.25H40V50.3125H30V40.25ZM30 60.375H40V70.4375H30V60.375ZM30 80.5H40V90.5625H30V80.5ZM30 100.625H40V110.688H30V100.625ZM55 60.375H85C87.7612 60.375 90 62.6277 90 65.4062C90 68.1848 87.7612 70.4375 85 70.4375H55C52.2388 70.4375 50 68.1848 50 65.4062C50 62.6277 52.2388 60.375 55 60.375ZM55 80.5H65C67.7612 80.5 70 82.7527 70 85.5312C70 88.3098 67.7612 90.5625 65 90.5625H55C52.2388 90.5625 50 88.3098 50 85.5312C50 82.7527 52.2388 80.5 55 80.5Z"
                    fill="black"
                    fillOpacity="0.87"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_21659">
                    <rect width="160" height="161" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EmptyWorkOrderSvg;
